import { fn } from '@ember/helper';
import { t } from 'ember-intl';
import eq from 'ember-truth-helpers/helpers/eq';
import or from 'ember-truth-helpers/helpers/or';
import BvBtn from 'volta/components/bv-btn';

import type { TOC } from '@ember/component/template-only';

export interface TasksKitViewSelectSignature {
  Args: {
    onViewChange: (view: 'resolved' | 'open') => void;
    resolvedCount?: number;
    selectedView: 'resolved' | 'open';
    unresolvedCount?: number;
    disabled?: boolean;
  };
  Element: HTMLElement;
}

const TasksKitViewSelectComponent: TOC<TasksKitViewSelectSignature> = <template>
  {{#let (eq @selectedView 'resolved') as |resolvedView|}}
    {{#if (or resolvedView @resolvedCount)}}
      <BvBtn
        @plain={{true}}
        @pressed={{resolvedView}}
        @onClick={{fn @onViewChange (if resolvedView 'open' 'resolved')}}
        @text={{if
          resolvedView
          (t 'tasksPage.unresolvedCount' count=@unresolvedCount)
          (t 'tasksPage.resolvedCount' count=@resolvedCount)
        }}
        ...attributes
      />
    {{/if}}

  {{/let}}
</template>;

export default TasksKitViewSelectComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TasksKit::ViewSelect': typeof TasksKitViewSelectComponent;
    'tasks-kit/view-select': typeof TasksKitViewSelectComponent;
  }
}
